import React from "react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

export default function AuditLogPage() {
  const [rows, setRows] = React.useState([]);
  const [q, setQ] = React.useState("");
  React.useEffect(() => { (async () => { const { data } = await api.get("/audit-logs"); setRows(data); })(); }, []);
  const filtered = rows.filter((r) => {
    if (!q) return true;
    const s = (r.user_email + " " + r.action + " " + r.record_type).toLowerCase();
    return s.includes(q.toLowerCase());
  });
  return (
    <div className="space-y-4" data-testid="audit-log-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>Audit Log</h1>
        <p className="text-sm text-neutral-500">Riwayat perubahan penting oleh pengguna.</p>
      </div>
      <input
        placeholder="Cari user / action / record type…"
        value={q} onChange={(e) => setQ(e.target.value)}
        className="border border-neutral-200 rounded-md px-3 py-2 text-sm w-full max-w-md"
        data-testid="audit-search"
      />
      <div className="card-flat overflow-x-auto">
        <table className="w-full data-table">
          <thead><tr>
            <th className="text-left">Waktu</th>
            <th className="text-left">User</th>
            <th className="text-left">Aksi</th>
            <th className="text-left">Record</th>
            <th className="text-left">ID</th>
          </tr></thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <td className="text-xs">{formatDateTime(r.timestamp)}</td>
                <td className="text-xs">{r.user_email || "-"}</td>
                <td className="text-xs uppercase">{r.action}</td>
                <td className="text-xs">{r.record_type}</td>
                <td className="text-xs font-mono truncate max-w-[280px]">{r.record_id}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-sm text-neutral-500">Tidak ada log.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
